import React, { useEffect, useState } from 'react';
import { Grid, ThemeProvider } from '@material-ui/core';
import { DropzoneAreaBase } from 'material-ui-dropzone';
import useStyles from './SubirArchivoStyle';
import { texts, pathIcono} from './SubirArchivoData';
import { AttachFile } from '@material-ui/icons';
import useOperations from './SubirArchivoFunction';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';



export default function SubirArchivo(props) {
    const { updateFormat, isPhoneVersion, cortarTexto, mostrarTextoEntero, mostrarTexto, getMaxFileSize, buildAcceptAttribute, getMimeType, getPreviewImage, getSafeFileName, getTipoSubido, getTipoEsperado } = useOperations();
    const { customStyle, theme } = useStyles(isPhoneVersion);
    const style = customStyle();
    const [previewImg, setPreviewImg] = useState(props.img || props.formato[0] === '.pdf' ? props.img : null);
    const imageMaxSize = props.tamMaximoArchivo * 1000000; //Bytes
    // Usamos la función buildAcceptAttribute para obtener los tipos de ficheros aceptados
    const acceptedFiles = buildAcceptAttribute(props.formato);

    const handleFileDrop = (files, rejectedFiles) => {
      if (files.length > 0) {
        const wrapper = files[0];
        const file = wrapper.file; // Accedemos al File real

        const fileName = getSafeFileName(wrapper);
        if (!fileName) {
          props.handleRejection([file]); //  pasamos el File real
          return;
        }

        const ext = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
        const mimeType = getMimeType(ext);
        if (mimeType === null) {
          props.handleRejection([file]);
          return;
        }

        const tipoSubido = getTipoSubido(mimeType);
        const tipoEsperado = getTipoEsperado(props.texto);

        if (tipoSubido !== tipoEsperado) {
          props.handleRejection([file]);
          return;
        }

        const maxSize = getMaxFileSize(ext, props.tamMaximoArchivo);
        if (file.size > maxSize) {
          props.handleRejection([file]);
          return;
        }

        const imgPath = getPreviewImage(ext);
        setPreviewImg(imgPath);

        // Si es PDF, pasamos el wrapper con base64 (para mantener .data)
        if (ext === '.pdf') {
          props.handleOnDrop([wrapper], rejectedFiles);
        } else {
          // Si es imagen o video, pasamos solo el File (sin base64)
          props.handleOnDrop([file], rejectedFiles);
        }
      }
    };

    useEffect(() => {
        updateFormat();
        window.addEventListener('resize', updateFormat);
        return () => window.removeEventListener('resize', updateFormat);
    }, []);



    return (
        <Grid className={style.clasGridContenedor}>
            <ThemeProvider theme={theme}>
                {mostrarTexto ? (
                    <Grid className={style.classDivIcon} onClick={mostrarTextoEntero}>
                        <KeyboardArrowDownIcon className={style.classIcon} />
                        <p title={props.texto} className={style.classTexto} >{props.texto}</p>
                    </Grid>
                            ) : (  
                    <Grid className={style.classDivIcon} onClick={mostrarTextoEntero}>
                        <KeyboardArrowRightIcon className={style.classIcon}/>   
                        <p title={props.texto} className={style.classTexto} onClick={mostrarTextoEntero}>{cortarTexto(props.texto)}</p>
                    </Grid>   
                )}
            <Grid>
                <Grid className={style.classGridImg}>
                    <img src={previewImg} className={style.classImg}/>
                    <p className={style.classParrafo}>{props.mostrarBotonEliminar ? texts.TAM : texts.MAX}{props.mostrarBotonEliminar ? props.tamDoc : props.tamMaximoArchivo}{texts.PESO}</p>
                </Grid>
                {!props.mostrarBotonEliminar &&
                    <DropzoneAreaBase
                    Icon={AttachFile}
                    acceptedFiles={acceptedFiles} // Usamos los tipos MIME calculados y buildAcceptedAttribute
                    dropzoneText={texts.TEXTO_DROP}
                    filesLimit={1}
                    onAdd={handleFileDrop}
                    maxFileSize={imageMaxSize}
                    onDropRejected={props.handleRejection}
                    showAlerts={[]}
                    />
                }
                {props.mostrarBotonEliminar &&
                    <button className={style.classButtonCancelar} name={props.id} onClick={props.bottonFunction}>{texts.ELIMINAR}</button>
                }
                
            </Grid>
            </ThemeProvider>
        </Grid>
        
    )
}